module.exports = __webpack_public_path__ + "img/page_background.21fce03c.png";